import React, { Component } from "react";
import { FullRow, Row, Col } from "../../framework/Grid";
import Expire from "../../framework/Expire";
import LinkButton from "../../framework/LinkButton";
import SelectedAttrs from "../SelectedAttrs";
import NavigationMoreHoriz from "material-ui/svg-icons/navigation/more-horiz";
import { Checkbox, IconButton, Popover, RaisedButton } from "material-ui";
import LimitExceededForm from "../Forms/LimitExceeded";

import { map, forEach, isEmpty } from "lodash";
import { primaryColor } from "../../../utils/utility";
import { parseSegment } from "../../../utils/segment_util";
import moment from "moment";
import { splitNumber } from "../../../utils/utility";

import Tooltip from "rc-tooltip";
import "rc-tooltip/assets/bootstrap_white.css";

import "./segment_confirm.css";
class Confirm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: 0,
      editNameMode: false,
      delay: 5,
      openCancel: false,
      segment_name: this.props.segment_name,
      disabledSaveBtn: false,
      showSaveErrorDialog: false,
      openContactForm: false,
      showSuccessForm: false,
      subject: "",
      comments: "",
    };
  }
  componentWillMount() {
    if (!this.props.selected_segments) window.location = "/segment/create";
  }

  componentDidMount() {
    if (
      !this.props.selected_client ||
      parseInt(this.props.selected_client, 10) < 1
    ) {
      window.location.href = "/";
    }
    const width = document.getElementById("Segment").clientWidth;
    this.setState({ width: width });
    if (!this.props.demoAttributes) {
      this.props.loadAttributes(this.props.selected_client);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.save_segment_success === false &&
      this.props.save_segment_success !== nextProps.save_segment_success
    ) {
      if (String(nextProps.save_segment_error_errorNo) === "422004")
        this.setState({
          showSaveErrorDialog: true,
          subject: "",
          comments: "",
          openContactForm: false,
        });
    }
    if (
      nextProps.request_assist_successful !==
      this.props.request_assist_successful
    ) {
      if (nextProps.request_assist_successful === true) {
        this.setState({
          showSuccessForm: true,
          openContactForm: false,
          showSaveErrorDialog: false,
        });
      }
    }
  }

  removeSelectedVal(id) {
    const { selected_segments } = this.props;
    const idx = selected_segments.indexOf(id);
    if (idx >= 0) {
      selected_segments.splice(idx, 1);
      this.props.selectSegment(selected_segments);
    }
  }

  saveSegmentName(e) {
    e.preventDefault();

    this.props.verifySegmentName(
      this.props.selected_client,
      this.state.segment_name,
    );
    this.setState({ errorVisible: false });

    setTimeout(
      function() {
        if (this.props.isNameDuplicated === false) {
          this.setState({
            editNameMode: false,
            delay: 2000,
            errorVisible: false,
          });
          this.props.setSegmentName(this.state.segment_name);
        } else {
          this.setState({ errorVisible: true, editNameMode: true });
        }
      }.bind(this),
      1500,
    );
  }
  cancelSegmentNameUpdate(e) {
    e.preventDefault();
    this.setState({ editNameMode: false, delay: 5 });
  }

  segmentNameComponent() {
    if (this.state.editNameMode === true) {
      return [
        <Col
          key="segment_name_update_1"
          xs="2"
          sm="2"
          md="2"
          lg="2"
          className="text-right"
          style={{ paddingRight: "12px" }}
        >
          <Tooltip
            visible={this.state.errorVisible}
            animation="zoom"
            trigger={[]}
            arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
            placement="top"
            overlayStyle={{ zIndex: 1000 }}
            overlay={
              <span>
                This segment name already exists, please enter a unique segment
                name to continue
              </span>
            }
          >
            <input
              className="pl-10"
              placeholder=" Name this Segment"
              style={{ width: "100%" }}
              onFocus={e => {
                e.preventDefault();
                this.setState({ errorVisible: false });
              }}
              onChange={e => {
                this.setState({ segment_name: e.target.value });
              }}
              value={this.state.segment_name}
            />
          </Tooltip>
        </Col>,
        <Col
          key="segment_name_update_2"
          xs="1"
          sm="1"
          md="1"
          lg="1"
          className="no-padding-left"
        >
          &nbsp;&nbsp;
          <a
            className="text-size-small"
            onClick={this.saveSegmentName.bind(this)}
          >
            Save
          </a>
          &nbsp;&nbsp;
          <a
            className="text-size-small"
            onClick={this.cancelSegmentNameUpdate.bind(this)}
          >
            Cancel
          </a>
        </Col>,
      ];
    } else {
      return [
        <Col
          key="segment_name_display_col"
          xs="2"
          sm="2"
          md="2"
          lg="2"
          style={{ overflow: "hidden", paddingRight: "12px" }}
          className="text-right no-padding-left"
        >
          <div style={{ float: "right" }} className="break-word-element">
            &nbsp;&nbsp;{this.props.segment_name}
          </div>
          <div
            style={{
              marginTop: "-10px",
              overflow: "hidden",
              borderBottom: "1px gray dashed",
            }}
          >
            &nbsp;
          </div>
        </Col>,
        <Col
          key="segment_name_action_col"
          xs="1"
          sm="1"
          md="1"
          lg="1"
          className="no-padding-left"
        >
          <Expire delay={this.state.delay} hasContainer={true}>
            <i className="icon-checkmark4 text-teal-400" />
            &nbsp;&nbsp;&nbsp;&nbsp;
          </Expire>
          <a
            onClick={e => {
              e.preventDefault();
              this.setState({ editNameMode: true });
            }}
          >
            <i className="icon-pencil4 text-teal-400" />
          </a>
        </Col>,
      ];
    }
  }

  handleOpenCancelDialog(e, status) {
    e.preventDefault();
    this.setState({
      openCancel: status,
      cancelAnchorEl: e.currentTarget,
    });
  }

  calTotalAudience() {
    const {
      audience_total_count,
      demoAttributes,
      selected_segments,
      plotted_values,
      selected_state,
      selected_city,
      selected_dma,
      selected_county,
      zipcode,
      active_segment_attributes,
    } = this.props;
    if (audience_total_count) return audience_total_count;
    if (!isEmpty(active_segment_attributes)) {
      return {
        total: active_segment_attributes.count,
        email: active_segment_attributes.email,
        display: active_segment_attributes.display,
        social: active_segment_attributes.social,
      };
    }
    let result = { total: 0, email: 0, display: 0, social: 0 };
    forEach(selected_segments, sid => {
      map(demoAttributes, cat => {
        map(cat.attributes, segment => {
          map(segment.values, val => {
            if (val.id === sid) {
              result.total += parseInt(val.total, 10);
              result.email += parseInt(val.email, 10);
              result.social += parseInt(val.social, 10);
              result.display += parseInt(val.display, 10);
            }
          });
          map(segment.subAttributes, subAttr => {
            map(subAttr.values, val => {
              if (val.id === sid) {
                result.total += parseInt(val.total, 10);
                result.email += parseInt(val.email, 10);
                result.social += parseInt(val.social, 10);
                result.display += parseInt(val.display, 10);
              }
            });
          });
        });
      });
    });

    if (plotted_values && plotted_values.audienceCount) {
      result.total += parseInt(plotted_values.audienceCount.total, 10);
      result.email += parseInt(plotted_values.audienceCount.email, 10);
      result.social += parseInt(plotted_values.audienceCount.social, 10);
      result.display += parseInt(plotted_values.audienceCount.display, 10);
    }

    result.total +=
      this.computedStateOrCityAttibute(selected_state, "total") +
      this.computedStateOrCityAttibute(selected_city, "total") +
      this.computedStateOrCityAttibute(zipcode, "total") +
      this.computedStateOrCityAttibute(selected_county, "total") +
      this.computedStateOrCityAttibute(selected_dma, "total");
    result.email +=
      this.computedStateOrCityAttibute(selected_state, "email") +
      this.computedStateOrCityAttibute(selected_city, "email") +
      this.computedStateOrCityAttibute(zipcode, "email") +
      this.computedStateOrCityAttibute(selected_county, "email") +
      this.computedStateOrCityAttibute(selected_dma, "email");
    result.social +=
      this.computedStateOrCityAttibute(selected_state, "social") +
      this.computedStateOrCityAttibute(selected_city, "social") +
      this.computedStateOrCityAttibute(zipcode, "social") +
      this.computedStateOrCityAttibute(selected_county, "social") +
      this.computedStateOrCityAttibute(selected_dma, "social");
    result.display +=
      this.computedStateOrCityAttibute(selected_state, "display") +
      this.computedStateOrCityAttibute(selected_city, "display") +
      this.computedStateOrCityAttibute(zipcode, "display") +
      this.computedStateOrCityAttibute(selected_county, "display") +
      this.computedStateOrCityAttibute(selected_dma, "display");

    return result;
  }

  computedStateOrCityAttibute(storeData, property) {
    return storeData
      ? storeData.reduce((acc, curr) => acc + curr[property], 0)
      : 0;
  }

  saveSegment() {
    if (this.state.disabledSaveBtn === true) return;
    else this.setState({ disabledSaveBtn: true });

    let segmentName = this.props.segment_name;
    const client_name = this.props.selected_client_name.split(" ").join("_");

    if (this.props.segment_name.indexOf(client_name) < 0)
      segmentName = (
        client_name +
        "_" +
        this.props.segment_name +
        "_" +
        moment().format("YYYYMMDD")
      )
        .split(" ")
        .join("_");
    const newSegment = parseSegment(this.props, segmentName);
    this.props.setSegmentName(segmentName);
    this.props.saveSegment(newSegment);
  }

  removePlottedVal() {
    this.props.setPlotValues({});
  }

  openContactFormClick(e) {
    e.preventDefault();
    this.setState({
      openContactForm: true,
      showSaveErrorDialog: false,
    });
  }

  onContactFormSubmit(e, subject, comments) {
    e.preventDefault();
    const postData = {
      clientId: this.props.selected_client,
      subject: subject.trim(),
      comment: comments.trim(),
      type: "upgrade",
      originationPage: "Audience Segment Maximum Threshold Overlay Message",
    };

    this.props.sendAssistRequest(postData);
  }

  cancelContactForm(e) {
    e.preventDefault();
    this.setState({
      openContactForm: false,
      showSaveErrorDialog: false,
    });
  }

  render() {
    const {
      selected_segments,
      plotted_values,
      selected_state,
      selected_city,
      selected_dma,
      selected_county,
      zipcode,
    } = this.props;
    let sltAttrCount = 0;
    if (selected_segments) sltAttrCount += selected_segments.length;
    if (!isEmpty(plotted_values)) sltAttrCount += 1;
    sltAttrCount += selected_state.length;
    sltAttrCount += selected_city.length;
    sltAttrCount += zipcode.length;
    if (selected_county) sltAttrCount += selected_county.length;
    if (selected_dma) sltAttrCount += selected_dma.length;
    const hasSelectedSegments = sltAttrCount > 0;
    const disabledSaveBtn =
      !hasSelectedSegments ||
      this.props.segment_name === "" ||
      this.state.editNameMode === true;
    const isWideScreen = this.state.width > 1900;
    return (
      <div className="no-padding no-margin">
        <h2>Create an Audience Segment</h2>
        <span className="font-12em">
          Review your inputs and selections you've made
        </span>
        <div
          className={
            isWideScreen
              ? "pl-20 pr-20 mt-20 pt-10 light-grey-background"
              : "pl-20 mt-20 pt-10 light-grey-background"
          }
        >
          <Row className="no-margin-bottom no-padding-bottom font-1em">
            <Col xs="4" sm="4" md="4" lg="4" className="no-padding-right">
              <div style={{ float: "left" }} className="text-teal-400">
                Audience Segment&nbsp;&nbsp;&nbsp;
              </div>
              <div
                style={{
                  marginTop: "-10px",
                  overflow: "hidden",
                  borderBottom: "1px gray dashed",
                }}
              >
                &nbsp;
              </div>
            </Col>
            {this.segmentNameComponent()}
          </Row>
          <Row className="no-padding-bottom no-margon-top pl-20 pr-20 font-1em">
            <Col xs="4" sm="4" md="4" lg="4" className="no-padding-right">
              <div style={{ float: "left" }} className="text-teal-400">
                Client&nbsp;&nbsp;&nbsp;
              </div>
              <div
                style={{
                  marginTop: "-10px",
                  overflow: "hidden",
                  borderBottom: "1px gray dashed",
                }}
              >
                &nbsp;
              </div>
            </Col>
            <Col
              xs="2"
              sm="2"
              md="2"
              lg="2"
              className="text-right no-padding-left"
              style={{ paddingRight: "12px", overflow: "hidden" }}
            >
              <div style={{ float: "right" }}>
                &nbsp;&nbsp;{this.props.selected_client_name}
              </div>
              <div
                style={{
                  marginTop: "-10px",
                  overflow: "hidden",
                  borderBottom: "1px gray dashed",
                }}
              >
                &nbsp;
              </div>
            </Col>
          </Row>
          <FullRow className="no-padding no-margin">
            <hr />
          </FullRow>
        </div>
        <div
          className={
            isWideScreen
              ? "pl-20 pr-20 light-grey-background"
              : "pl-20 light-grey-background"
          }
        >
          <FullRow className="no-padding-bottom no-margin-bottom no-margin-top no-padding-top">
            <h3>
              Attributes
              <span className="ml-5" style={{ fontSize: "0.8em" }}>
                ({sltAttrCount})
              </span>
            </h3>
          </FullRow>
          {/*
					<Row className="no-padding-bottom no-margin-bottom no-margin-top no-padding-top text-grey">
						<Col xs="8" sm="8" md="8" lg="8">
							<Row className="no-padding no-margin">
								<Col xs="7" sm="7" md="7" lg="7" className="no-padding-right no-padding-left">
									ATTRIBUTE
								</Col>
								<Col xs="2" sm="2" md="2" lg="2" className="text-right">
									COUNT
								</Col>
							</Row>
						</Col>
					</Row>*/}
          <Row className="no-padding-bottom no-margin-bottom no-margin-top no-padding-top text-grey">
            <Col xs="5" sm="5" md="5" lg="5">
              ATTRIBUTE
            </Col>
            <Col
              xs="1"
              sm="1"
              md="1"
              lg="1"
              className="text-right"
              style={{ paddingRight: "12px" }}
            >
              COUNT
            </Col>
          </Row>
        </div>
        <div className="light-grey-background font-1em">
          <Row className="no-padding no-margin">
            <Col xs="8" sm="8" md="8" lg="8" className="no-padding-left">
              <SelectedAttrs
                selected_state={this.props.selected_state}
                selected_city={this.props.selected_city}
                selected_county={this.props.selected_county}
                selected_dma={this.props.selected_dma}
                clearAllSelectedState={this.props.clearAllSelectedState}
                clearAllSelectedCity={this.props.clearAllSelectedCity}
                clearAllCounty={this.props.clearAllCounty}
                clearAllDMA={this.props.clearAllDMA}
                selectState={this.props.selectState}
                selectCity={this.props.selectCity}
                selectCounty={this.props.selectCounty}
                selectDMA={this.props.selectDMA}
                selectedAttrs={this.props.selected_segments}
                plottedRadius={this.props.plotted_values}
                categories={this.props.demoAttributes}
                width={this.state.width}
                hideTitle={true}
                removeAttribute={this.removeSelectedVal.bind(this)}
                removePlottedVal={this.removePlottedVal.bind(this)}
                zipcode={this.props.zipcode}
                clearAllZipCode={this.props.clearAllZipCode}
                clearZipCode={this.props.clearZipCode}
              />
            </Col>
          </Row>
          <FullRow className="no-padding no-margin pl-20 pr-20">
            <hr />
          </FullRow>
          <Row className={"no-padding no-margin pt-20 pl-20 "}>
            <Col xs="4" sm="4" md="4" lg="4" className="pl-20">
              <span>
                <label>Audience</label>
              </span>
              <Checkbox
                style={{
                  marginLeft: "40px",
                  position: "absolute",
                  display: "inline",
                }}
                label="Target Primary Decision Maker"
                labelStyle={{ width: "115%" }}
                defaultChecked={Boolean(this.props.targetHouseholdsOnly)}
                disabled={true}
              />
            </Col>
            <Col
              xs="2"
              sm="2"
              md="2"
              lg="2"
              className="no-padding-left text-right"
              style={{ paddingRight: "20px" }}
            >
              <span className="text-default text-bold font-12em">
                {splitNumber(this.calTotalAudience().total + "")()}
              </span>
            </Col>
            <Col
              xs="2"
              sm="2"
              md="2"
              lg="2"
              style={{ marginLeft: "-10px" }}
              className="no-padding-left text-center"
            >
              Reach by Channel
            </Col>
            <Col xs="4" sm="4" md="4" lg="4">
              <Row className="no-padding pr-20">
                <Col
                  xs="4"
                  sm="4"
                  md="4"
                  lg="4"
                  className="no-padding-left no-padding-right"
                >
                  <p>
                    <i className="icon-envelope" />
                    <span className="ml-5 text-default text-bold">
                      {splitNumber(this.calTotalAudience()["email"] + "")()}
                    </span>
                  </p>
                </Col>
                <Col
                  xs="4"
                  sm="4"
                  md="4"
                  lg="4"
                  className="no-padding-left no-padding-right"
                >
                  <p>
                    <i className="icon-share3" />
                    <span className="ml-5 text-default text-bold">
                      {splitNumber(this.calTotalAudience()["social"] + "")()}
                    </span>
                  </p>
                </Col>
                <Col
                  xs="4"
                  sm="4"
                  md="4"
                  lg="4"
                  className="no-padding-left no-padding-right"
                >
                  <p className="pull-left">
                    <i className="icon-display4" />
                    <span className="ml-5 text-default text-bold">
                      {splitNumber(this.calTotalAudience()["display"] + "")()}
                    </span>
                  </p>
                  <IconButton
                    className="pull-right no-margin no-padding"
                    style={{ width: "24px", height: "24px" }}
                  >
                    <NavigationMoreHoriz
                      className="text-grey-400"
                      style={{ width: "24px", height: "24px" }}
                    />
                  </IconButton>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
        <Row className="pt-20">
          <Col xs="3" sm="3" md="3" lg="3" style={{ paddingLeft: "20px" }}>
            <LinkButton
              to="/segment/create"
              backgroundColor={primaryColor()}
              labelColor="#FFF"
              label="<&nbsp;Previous"
              style={{
                float: "left",
                marginRight: "10px",
                marginBottom: "10px",
                marginTop: "20px",
                backgroundColor: primaryColor(),
              }}
            />
            <Popover
              open={this.state.openCancel}
              anchorEl={this.state.cancelAnchorEl}
              anchorOrigin={{ horizontal: "right", vertical: "top" }}
              targetOrigin={{ horizontal: "left", vertical: "center" }}
              onRequestClose={this.handleRequestClose}
            >
              <FullRow className="text-default">
                Are you sure you want to exit?
                <br />
                Any selections you have made will not be saved
                <br />
                <br />
                <a
                  className="btn btn-link btn-sm cancel-btn mr-20"
                  onClick={e => {
                    this.handleOpenCancelDialog(e, false);
                  }}
                >
                  Close
                </a>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <a
                  className="btn btn-default btn-round btn-sm btn-aa-primary ml-20"
                  onClick={e => {
                    e.preventDefault();
                    window.sessionStorage.setItem("clearAll", true);
                    window.location =
                      "/segments/list/active?cid=" + this.props.selected_client;
                  }}
                >
                  Yes, exit
                </a>
              </FullRow>
            </Popover>
            <a
              className="btn btn-link pull-left "
              style={{ marginLeft: "10px" }}
              onClick={e => {
                this.handleOpenCancelDialog(e, true);
              }}
            >
              Cancel
            </a>
          </Col>
          <Col xs="9" sm="9" md="9" lg="9" className="text-right pr-20">
            <RaisedButton
              disabled={disabledSaveBtn || this.state.disabledSaveBtn}
              backgroundColor={primaryColor()}
              labelColor="#FFF"
              disabledBackgroundColor="gray"
              disabledLabelColor="lightGray"
              onTouchTap={this.saveSegment.bind(this)}
              style={{ marginBottom: "10px", backgroundColor: primaryColor() }}
              label="Save"
            />
          </Col>
        </Row>
        <LimitExceededForm
          showSaveErrorDialog={this.state.showSaveErrorDialog}
          history={this.props.history}
          showSuccessForm={this.state.showSuccessForm}
          openContactForm={this.state.openContactForm}
          roleId={this.props.roleId}
          openContactFormClick={this.openContactFormClick.bind(this)}
          cancelContactForm={this.cancelContactForm.bind(this)}
          onContactFormSubmit={this.onContactFormSubmit.bind(this)}
        />
      </div>
    );
  }
}

export default Confirm;



// WEBPACK FOOTER //
// ./src/components/Segment/Confirm/index.js